export enum DrawingButtonsModeName {
  marker = 'marker',
  area = 'area',
  circle = 'circle',
}
